import React from 'react';
import { connect } from 'react-redux';
import overrideStyle from 'lib/overrideStyle';
import PropTypes from 'prop-types';

import { startInteractiveOnboarding } from 'app/modules/ui/actions';

const Wrapper = overrideStyle('button')`
    background: ${props => props.colors.primary};
    border: 1px solid ${props => props.colors.primary};
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    color: white;
    height: 32px;
    justify-content: center;
    margin-top: 25px;
    width: 140px;
`;

class ChatWithAgentButton extends React.Component {
  constructor(props) {
    super(props);

    const ChatWithAgentButtonPropTypes = {
      onClick: PropTypes.func.isRequired,
      colors: PropTypes.object.isRequired,
    };
    PropTypes.checkPropTypes(ChatWithAgentButtonPropTypes, props, 'props', 'ChatWithAgentButton');

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.onClick();
  }

  render() {
    return (
      <Wrapper onClick={this.handleClick} colors={this.props.colors}>
        Chat with an agent
      </Wrapper>
    );
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    onClick: () => {
      dispatch(startInteractiveOnboarding());
    },
  };
};

export const mapStateToProps = state => {
  return { thing: false };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatWithAgentButton);
